import { Controller } from '@hotwired/stimulus';
import { MDCLinearProgress } from '@material/linear-progress';
import { RDAudioEventCapture } from 'raindrops';
import { FetchRequest } from '@rails/request.js';

const percentCompleteBenchmarks = [0, 25, 50, 95, 100];

export default class extends Controller {
  static values = {
    audioType: String
  };

  connect() {
    this.currentPercent = 0;
    RDAudioEventCapture.initialize((audioForm) => {
      this.submitForm(audioForm);
    },
    ['play', 'pause', 'ended', 'timeupdate']);
    this.initializeControls();
    this.audioEventSeconds = [];
    this.calculateAudioEventSeconds();
  }

  toggleWatchedWithChild(event) {
    const formData = new FormData();
    formData.set('audio_action[kind]', 'watched-together');
    formData.set('audio_action[current_playback_percent]', '100');
    formData.set('audio_action[current_playback_time_in_s]', '0');
    formData.set('audio_action[audio_type]', event.params.audioType);
    formData.set('audio_action[audio_id]', event.params.audioId);
    (new FetchRequest('post', event.params.url, { body: formData })).perform();
  }

  calculateAudioEventSeconds() {
    const audio = document.getElementById('parent-radio-audio');
    percentCompleteBenchmarks.forEach((percentage) => {
      this.audioEventSeconds.push(
        Math.floor((parseFloat(audio.duration) * percentage) / 100)
      );
    });
  }

  submitForm(audioForm) {
    if (
      audioForm.querySelector(
        '[name="audio_action[current_playback_percent]"]'
      ) == null
    ) {
      audioForm.insertAdjacentHTML(
        'beforeend',
        `<input name="audio_action[current_playback_percent]" value="${this.currentPercent}" />`
      );
      audioForm.insertAdjacentHTML(
        'beforeend',
        `<input name="audio_action[audio_type]" value="${this.audioTypeValue}" />`
      );
    } else {
      audioForm.querySelector(
        '[name="audio_action[current_playback_percent]"]'
      ).value = this.currentPercent;
    }
    const formData = new FormData(audioForm);

    if (this.eventKind(audioForm) == 'timeupdate') {
      let currentSecond = audioForm.querySelector(
        "[name='audio_action[current_playback_time_in_s]']"
      ).value;
      let audioMarker = document.querySelector('[data-last-second-value]');
      if (audioMarker) {
        for (let secondsTarget of this.audioEventSeconds) {
          if (
            parseFloat(audioMarker.dataset.lastSecondValue) < secondsTarget &&
            secondsTarget < parseFloat(currentSecond)
          ) {
            (new FetchRequest('post', audioForm.action, { body: formData })).perform();
            break;
          }
        }
        audioMarker.dataset.lastSecondValue = currentSecond;
      }
    } else {
      new FetchRequest('post', audioForm.action, { body: formData }).perform();
    }
  }

  eventKind(audioForm) {
    return audioForm.querySelector("[name='audio_action[kind]']").value;
  }

  initializeControls() {
    var lastTimeupdatePercent = 0;

    const playButton = document.getElementById('parent-radio-play-button');
    const progressElement = document.getElementById('parent-radio-progress');
    const skipBackButton = document.getElementById(
      'parent-radio-skip-back-button'
    );
    const skipForwardButton = document.getElementById(
      'parent-radio-skip-forward-button'
    );

    const audio = document.getElementById('parent-radio-audio');

    audio.addEventListener('durationchange', () => {
      document.getElementById('time-remaining').innerHTML =
        '-' + formatSeconds(audio.duration - audio.currentTime);
    });

    const buttonLabel =
      playButton.getElementsByClassName('mdc-button__label')[0];
    const progressIndicator = new MDCLinearProgress(progressElement);

    function formatSeconds(seconds) {
      if (Number.isNaN(seconds)) {
        return "0";
      }

      return new Date(1000 * seconds).toISOString().substr(14, 5);
    }

    audio.addEventListener('play', (event) => {
      const iconElement = playButton.querySelector('i');
      iconElement.classList.remove('fa-play');
      iconElement.classList.add('fa-pause');
    });

    audio.addEventListener('pause', (event) => {
      const iconElement = playButton.querySelector('i');
      iconElement.classList.remove('fa-pause');
      iconElement.classList.add('fa-play');
    });

    audio.addEventListener('timeupdate', () => {
      document.getElementById('time-elapsed').innerHTML = formatSeconds(
        audio.currentTime
      );
      document.getElementById('time-remaining').innerHTML =
        '-' + formatSeconds(audio.duration - audio.currentTime);

      // prevent divide by 0 error
      const duration =
        audio.duration == null || audio.duration == 0 ? 0.1 : audio.duration;
      const amountComplete = audio.currentTime / duration;
      progressIndicator.progress = amountComplete;

      const newTimeupdatePercent =
        (event.currentTarget.currentTime / event.currentTarget.duration) *
        100;
      lastTimeupdatePercent = newTimeupdatePercent;
      this.currentPercent = newTimeupdatePercent;
    });

    let playResolved = true;
    playButton.addEventListener('click', () => {
      if (audio.paused) {
        playResolved = false;
        audio
          .play()
          .then(() => {
            playResolved = true;
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              throw error;
            }
          });
      } else if (playResolved) {
        audio.pause();
      }
    });

    skipBackButton.addEventListener('click', () => {
      audio.currentTime = audio.currentTime - 15.0;
    });

    skipForwardButton.addEventListener('click', () => {
      audio.currentTime = audio.currentTime + 15.0;
    });
  }
}
